/* eslint-disable no-unused-vars */
import React, { useEffect, useState } from "react";
import {
  Box,
  Container,
  Grid,
  ImageListItem,
  Typography,
  ImageListItemBar,
} from "@mui/material";
import { Link, useNavigate } from "react-router-dom";
import description from "../images/description.jpg";
import "../styles/Landing.css";
import { toast } from "react-toastify";
import HomepageFooter from "../partials/footer/homefooter"
import { useSelector } from "react-redux";
import { API } from "./backend";
import axios from "axios";
import ileraBanner from "../assets/images/banner.jpeg";
import IleraBanner from "../Component/IleraBanner";


// import guide from "../images/guide.pdf";

const itemData = [
  {
    img: "/assets/images/code.jpg",
    title: (
      <>
        Apply for School <br />
        Code
      </>
    ),

    // "Apply for School Code",
    descriptiom: "a",
    link: "/requisition/apply-schoolId",
    btnText: "Download Userguide",
    // dwnldLink: ""
  },
  {
    img: "/assets/images/bece.jpg",
    title: "B.E.C.E",
    descriptiom: "b",
    link: "bece/payment/login",
    btnText: "Download Userguide",
    dwnldLink:
      "https://scribehow.com/shared/How_to_Generate_and_Pay_for_BECE_Exam_Invoice__mmTeRW4tT4-IOJCpvguQdw",
  },
  {
    img: "/assets/images/code.jpg",
    title: "CAS/Placement",
    descriptiom: "c",
    link: "cas/payment/login",
    btnText: "Download Userguide",
    dwnldLink:
      "https://scribehow.com/shared/How_to_Generate_and_Pay_for_BECE_Exam_Invoice__mmTeRW4tT4-IOJCpvguQdw",
  },
  {
    img: "/assets/images/exam.jpg",
    title: "Public Service",
    descriptiom: "d",
    link: "public/payment/login",
    btnText: "Download Userguide",
    dwnldLink:
      "https://scribehow.com/shared/How_to_Generate_and_Pay_for_BECE_Exam_Invoice__mmTeRW4tT4-IOJCpvguQdw",
  },
  {
    img: "/assets/images/trade.jpg",
    title: "Trade Test",
    descriptiom: "e",
    link: "tradetest/payment/login",
    btnText: "Download Userguide",
    dwnldLink:
      "https://scribehow.com/shared/How_to_Generate_and_Pay_for_BECE_Exam_Invoice__mmTeRW4tT4-IOJCpvguQdw",
  },
  {
    img: "/assets/images/screen.jpg",
    title: (
      <>
        Screening/Model <br />
        College
      </>
    ),
    // "Screening/Model College",
    descriptiom: "f",
    link: "model/payment/login",
    btnText: "Download Userguide",
    dwnldLink:
      "https://scribehow.com/shared/How_to_Generate_and_Pay_for_BECE_Exam_Invoice__mmTeRW4tT4-IOJCpvguQdw",
  },
  {
    img: "/assets/images/exam.jpg",
    title: "TEDAC",
    descriptiom: "g",
    link: "tedac/payment/login",
    btnText: "Download Userguide",
    // dwnldLink: ""
  },
];

const Landing = () => {
  const [hover, setHover] = useState(false);
  const navigate = useNavigate();
  const [dates, setDates] = useState([]);
  const token = useSelector((state) => state?.user?.data?.token);

   // getting the dates
  //  const getAllDates = async () => {
  //   try {
  //     const response = await axios.get(`${API}/dates/all`, {
  //       headers: {
  //         "Content-Type": "application/json",
          
  //       },
  //     });
  //     // console.log(response?.data?.data?.details, ",,,,");
  //     if (response) {
  //       // console.log(response?.data?.data?.details, ",,,,");
  //       setDates(response?.data?.data?.details?.rows);
  //       return response;
  //     } else {
  //       console.log(response, "response");
  //     }
  //     // console.log(response, "superres");
  //   } catch (error) {
  //     if (error.code === "ERR_NETWORK") {
  //       toast.error("Please check your internet connection");
  //     } else {
  //       if (error?.response?.status === 403) {
  //       }
  //     }
  //     throw error;
  //   }
  // };

  // useEffect(() => {
  //   getAllDates();
  // }, []);

  return (
    <div
      // component="div"
      className="landing"
      style={{ backgroundColor: "#F5F5F5" }}
    >
      <Box
        style={{
          width: "100%",
          height: "320px",
          // position: 'sticky',
          // top:'0',
          // zIndex: '1000',
          background:
            'linear-gradient(rgba(0, 0, 0, 0.7), rgba(0, 0, 0, 0.9)), url("https://res.cloudinary.com/dmrtylvtc/image/upload/c_crop,w_5945,h_1050,g_auto/v1709124010/wepik-export-20240228123913coZu_xowo7f.png")',
          backgroundSize: "100%",
        }}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            padding: window.innerWidth >= 800 ? "0px 50px" : "0px",
          }}
        >
          <div className="home-page-text" style={{ width: "60%" }}>
            <Typography color={"white"} fontSize={"22px"} fontWeight={"bold"}>
              WELCOME TO THE
            </Typography>
            <Typography
              color={"white"}
              fontSize={{
                // xs: "28px",
                // Set font size for extra small screens
                md: "32px",
                // Set font size for medium screens and above
              }}
              fontWeight={"bold"}
            >
              LAGOS STATE EXAMINATIONS BOARD
            </Typography>
            <Typography color={"white"} fontSize={"22px"} fontWeight={"bold"}>
              ONLINE PORTAL
            </Typography>
          </div>

          <div>
            <img
              src={
                "/assets/images/laags.png"
              }
              alt="lag"
              objectFit={'contain'}
              style={{
                width: "15rem",
                display: "block",
                margin: "0 auto",
              }}
              sx={{ width: { sm: "2rem" } }}
            />
          </div>
        </div>
      </Box>
      {/* Ilera Eko Banner Component */}
      <IleraBanner image={ileraBanner} />

      {/* text */}
      <div>
        <div>
          <Typography
            // variant="h4"
            align="center"
            style={{
              paddingTop: "3rem",
              paddingBottom: "2rem",
              fontWeight: "bold",
            }}
            sx={{ fontSize: { xs: "1.5rem", md: "2rem" } }}
          >
            REQUEST FOR EXAMS SERVICE
          </Typography>
        </div>

        {/*  the image */}
        <Box
          sx={{
            display: "flex",
            flexWrap: "wrap",
            gap: "24px",
            justifyContent: "center",
            alignItems: "center",
            padding: {
              xs: "20px 10px 10px 10px",
              md: "20px 100px 100px 100px"
            }
          }}
        >
          {/* <img
          src={"/assets/images/laags.png"}
          alt="lag"
          style={{
            width: "15rem",
            display: "block",
            margin: "0 auto",
          }}
          sx={{ width: { xs: "5rem" } }}
        /> */}

          {/* <Card className="landing-card" elevation={5}> */}

          
          <Grid container rowSpacing={{ xs: 4, sm: 5, md: 6, lg: 7 }} columnSpacing={{ xs: 0, sm: 6, md: 8, lg: 0 }}
          >
            {/* rowSpacing={7} columnSpacing={5} */}
            {itemData.map((item, index) => (
              <Grid item xs={12} sm={6} md={4} key={index}
                align="center">


                <Box
                  className="gridContainer"
                  sx={{
                    boxShadow: "0px 0px 4px 4px rgba(52, 165, 111, 0.10)",
                    padding: "28px 30px",
                    width: { xs: "95%", sm: "85%" },
                    height: '330px',
                    borderRadius: "16px",
                    display: "inline-flex",
                    flexDirection: "column",
                    gap: "16px",
                    border: "2px solid #D8EBDA",
                    backgroundColor: '#F5F5F5',
                    transition: 'transform 0.3s ease-in-out',
                    '&:hover': {
                      transform: 'scale(1.04)',
                      background: 'linear-gradient(rgba(113, 155, 128, 0.95), rgba(224, 224, 224, 0.9))'
                    }
                  }}
                >

                  <div
                    style={{
                      position: "relative",
                      // marginBottom: "2rem",
                      width: "100%",
                      height: "100%",

                      // borderRadius: "20px",

                      // display: 'flex',
                      // gap: '10px',
                    }}
                    //  item.link === "bece/payment/login"
                    // item.link === "public/payment/login"
                    //item.link === "tradetest/payment/login" 
                    //item.link === "/requisition/apply-schoolId"
                    //item.link === "cas/payment/login" 
                    // item.link ===  "model/payment/login" 
                    onClick={() => ( item.link === "tedac/payment/login " ||  item.link === "tedac/payment/login" ) ? toast.error('This service is unavailable. New exam date will be communicated.') : navigate(item.link)}
                  >
                    <ImageListItem
                      key={item.img}
                      style={{
                        position: "relative",
                        // marginBottom: "2rem",
                        width: "100%",
                        height: "100%",
                        cursor: 'pointer',
                        borderRadius: "14px",

                        // display: 'flex',
                        // gap: '10px',
                      }}
                    >
                      {/* <Link to={item.link} className="landing-link"> */}
                      <img
                        src={`${item.img}`}
                        alt={item.title}
                        style={{ borderRadius: "15px", width: "100%", }}
                      />

                      {/* </Link> */}
                      <ImageListItemBar
                        style={{
                          position: "absolute",
                          top: "0",
                          textAlign: "center",
                          borderRadius: "1rem",
                          fontWeight: "bold",
                          fontSize: "2rem",
                          paddingTop: "8rem",
                        }}
                        title={
                          <Typography
                            textAlign="center"
                            justifyContent={"center"}
                            // display={'flex'}
                            style={{
                              fontSize: "28px",
                              fontWeight: '600'
                              // display: 'flex'
                            }}
                          >
                            {item.title}
                          </Typography>
                        }

                      />
                    </ImageListItem>

                    {/* <Box component={'button'} style={{ textDecoration: 'none',  border: '1px solid red', padding: '5px', height:'30px', cursor: 'pointer', borderRadius:'5px', marginBottom:'10px' }}  ><Typography textDecoration={'none'} > Download Userguide</Typography></Box> */}
                  </div>
                </Box>
              </Grid>
            ))}
          </Grid>

        </Box>

      </div>
      <HomepageFooter />
    </div>
  );
};

export default Landing;
